export type UserDetails = {
  permissions: string[];
  personas: Persona[];
  activePersona: Persona;
  isMt: boolean;
  isSt: boolean;
  isInternal: boolean;
};

export type BiUserView = {
  userId: string;
  dashboards: DashboardView[];
};

export type DashboardView = {
  id: string;
  title: string;
  description: string;
  thumbnailLight: string;
  thumbnailDark: string;
  order: number;
};

export type UserDashboardStatusType = 'FIRST_AUTHENTICATION_ATTEMPT' | 'RETRYING_AUTHENTICATION' | 'MAX_AUTHENTICATION_RETRIES_REACHED' | 'USER_NOT_FULLY_SETUP' | 'USER_AUTHENTICATED_WITH_DASHBOARDS';

export const UserDashboardStatus = {
  FIRST_AUTHENTICATION_ATTEMPT: 'FIRST_AUTHENTICATION_ATTEMPT',
  RETRYING_AUTHENTICATION: 'RETRYING_AUTHENTICATION',
  MAX_AUTHENTICATION_RETRIES_REACHED: 'MAX_AUTHENTICATION_RETRIES_REACHED',
  USER_NOT_FULLY_SETUP: 'USER_NOT_FULLY_SETUP',
  USER_AUTHENTICATED_WITH_DASHBOARDS: 'USER_AUTHENTICATED_WITH_DASHBOARDS'
} as const;

export type SigmaAuthenticationStatusType = 'NOT_AUTHENTICATED' | 'AUTHENTICATING' | 'AUTHENTICATION_FAILED' | 'AUTHENTICATED';

export const SigmaAuthenticationStatus = {
  NOT_AUTHENTICATED: 'NOT_AUTHENTICATED',
  AUTHENTICATING: 'AUTHENTICATING',
  AUTHENTICATION_FAILED: 'AUTHENTICATION_FAILED',
  AUTHENTICATED: 'AUTHENTICATED'
} as const;

export type SigmaInfo = {
  authenticationStatus: SigmaAuthenticationStatusType;
  dashboardsNo: number;
  defaultDashboardId: string;
  dashboards: DashboardView[];
};
